/**
 * Bazaarvoice full reviews section for PDP (bottom of page).
 */
import PropTypes from 'prop-types';

import {Box} from '@salesforce/retail-react-app/app/components/shared/ui';

import {useBazaarvoiceScript} from '@amblique/king-living/app/hooks/use-bazaarvoice-script';
import {useSitePreference} from '@amblique/base/app/hooks/use-site-preference';
import {
  BAZAARVOICE_REVIEWS_SECTION_ID,
  getBazaarvoiceProductId,
  isBazaarvoiceConfigured,
} from '@amblique/king-living/app/utils/bazaarvoice';

/**
 * @param {object} props
 * @param {object} props.product - SCAPI product
 * @returns {React.ReactElement|null}
 */
export function ProductBazaarvoice({product}) {
  const bazaarvoicePrefs = useSitePreference('bazaarvoice');
  useBazaarvoiceScript(isBazaarvoiceConfigured(bazaarvoicePrefs));
  const productId = getBazaarvoiceProductId(product);

  if (!isBazaarvoiceConfigured(bazaarvoicePrefs) || !productId) {
    return null;
  }

  return (
    <Box
      aria-label="Customer reviews"
      as="section"
      className="sf-product-bazaarvoice"
      data-testid="product-bazaarvoice"
      id={BAZAARVOICE_REVIEWS_SECTION_ID}
      layerStyle="fullWidth"
    >
      <div data-bv-product-id={productId} data-bv-show="reviews" />
    </Box>
  );
}

ProductBazaarvoice.propTypes = {
  product: PropTypes.object,
};

export default ProductBazaarvoice;
